import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { useImpersonation } from "@/contexts/ImpersonationContext";

function formatRemaining(expiresAt: number, now: number): string {
  const seconds = Math.max(0, Math.ceil((expiresAt - now) / 1000));
  const minutes = Math.floor(seconds / 60);
  return `${minutes}:${String(seconds % 60).padStart(2, "0")}`;
}

export const ImpersonationBanner = () => {
  const { state, isSwitching, returnToAdmin } = useImpersonation();
  const [now, setNow] = useState(Date.now);

  useEffect(() => {
    if (!state) return;
    const interval = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(interval);
  }, [state]);

  if (!state) return null;

  return (
    <div
      className="sticky top-0 z-[150] flex w-full flex-wrap items-center justify-center gap-x-2 gap-y-1 bg-red-700 px-3 py-2 text-center text-sm font-bold text-white shadow-md dark:bg-red-800"
      role="status"
      aria-live="assertive"
      translate="no"
    >
      <span>
        VIEWING AS {state.targetName} · read-only · back to admin in{" "}
        {formatRemaining(state.expiresAt, now)}
      </span>
      <Button
        type="button"
        size="sm"
        variant="secondary"
        className="h-7 bg-white px-2 text-red-800 hover:bg-red-100"
        disabled={isSwitching}
        onClick={() => void returnToAdmin()}
      >
        Back to admin
      </Button>
    </div>
  );
};
